import { push } from 'react-router-redux';

import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import findLastIndex from 'lodash/findLastIndex';

import pagesStore from 'zoomforth_zf/appglobals/pages.js';
import routesStore from 'zoomforth_zf/appglobals/routes.js';
import PageCollection from 'zoomforth_zf/models/page.collection.js';

import { getForPage as getPageHistoryTrackerForPage } from 'zoomforth_zf/appglobals/page-history-tracker.js';
import { get as intercomTracker } from 'zoomforth_zf/appglobals/intercom-tracker.js';

import {
  deleteRoute,
  deletePage
} from './page_and_link_management.js';

import {
  setFolderIdForNewPage
} from './misc_settings.js';

import {
  OPEN_SHARED_MANAGEMENT_MODAL,
  UPDATE_SHARED_MANAGEMENT_MODAL,
  CLOSE_SHARED_MANAGEMENT_MODAL,
  DESTROY_SHARED_MANAGEMENT_MODAL
} from '../const/action_types.js';

import {
  CREATE_PAGE_OR_TEMPLATE_MODAL_NAME,
  CREATE_PAGE_FROM_TEMPLATE_MODAL_NAME,
  LINK_CREATOR_MODAL_NAME,
  FOLDER_MANAGER_MODAL_NAME, 
  PAGE_DETAILS_MODAL_NAME, 
  PAGE_DELETER_MODAL_NAME,
  LINK_DETAILS_MODAL_NAME, 
  TEMPLATE_DETAILS_MODAL_NAME, 
  ROUTE_DELETER_MODAL_NAME, 
  PAGE_REDIRECTOR_MODAL_NAME, 
  LINK_SHARER_MODAL_NAME,
  SITE_DEACTIVATOR_MODAL_NAME,
  EXPORT_SITE_MODAL_NAME,
  SITE_PREVIEW_COLLABORATION_MODAL_NAME,
} from '../const/modal_names.js';

import {
  getLocationBeforeTransitions
} from 'zoomforth_shared_management/reducers/index.js';
 
import folderStore from 'zoomforth_zf/appglobals/page-folders.js';

import {
  serializeDetailItem, 
  deserializeDetailItem
} from 'zoomforth_shared_management/lib/details_modal_serializer.js';

// How long is the animation for the closing of the details modal
export const CLOSING_DURATION = 250; 


export const openManagementModal = (name, props)=> {
  return {
    type: OPEN_SHARED_MANAGEMENT_MODAL,
    name,
    props
  };
};

export const closeManagementModal = (name, { delay=CLOSING_DURATION }={})=>
  (dispatch)=> {

    dispatch({
      type: CLOSE_SHARED_MANAGEMENT_MODAL,
      name
    });
    setTimeout(()=> {
      dispatch({ 
        type: DESTROY_SHARED_MANAGEMENT_MODAL,
        name
      });
    }, delay);

  };


const openDetails = (type, item, tab)=>
  (dispatch, getState)=> {
    const location = getLocationBeforeTransitions(getState());
    const itemId = item.id ? item.id : item;

    if (type === 'site') {
      intercomTracker().trackViewPageDetailsTab(itemId, tab);
    } else if (type === 'link') {
      intercomTracker().trackViewLinkDetailsTab(itemId, tab);
    }

    const detailsPrefix = location.query.details ? `${location.query.details};` : '';

    dispatch(push({ 
      ...location, 
      query: { 
        ...location.query,
        details: `${detailsPrefix}${serializeDetailItem({ type, tab, id: itemId })}`,
      } 
    }));
  };

const closeDetails = (type)=> 
  (dispatch, getState)=> { 

    const location = getLocationBeforeTransitions(getState());
    const { details, ...query } = location.query;
    if (!details) {
      // Ignore close action if details are already missing
      return;
    }
    const detailItems = map(details.split(';'), deserializeDetailItem);
    detailItems.splice(findLastIndex(detailItems, ['type', type]), 1); // Remove last item of type
    const newDetails = map(detailItems, serializeDetailItem);

    dispatch(push({
      ...location,
      query: {
        ...query,
        ...(isEmpty(newDetails) ? null : { details: newDetails.join(';') })
      }
    }));
  };


const selectTabInDetails = (type, tab)=> 
  (dispatch, getState)=> {
    const location = getLocationBeforeTransitions(getState());
    const detailItems = map(location.query.details.split(';'), deserializeDetailItem);
    const detailItemIndex = findLastIndex(detailItems, ['type', type]);
    const { id } = detailItems[detailItemIndex];
    detailItems.splice(detailItemIndex, 1, { id, type, tab: tab }); // Remove last item of type

    if (type === 'site') {
      intercomTracker().trackViewPageDetailsTab(id, tab);
    } else if (type === 'link') {
      intercomTracker().trackViewLinkDetailsTab(id, tab);
    }

    dispatch(push({ 
      ...location, 
      query: { 
        ...location.query, 
        details: map(detailItems, serializeDetailItem).join(';')
      } 
    }));
  };


export const openPageDetails = (page, tab = 'summary')=>
  openDetails('site', page, tab);

export const openTemplateDetails = (template, tab = 'summary')=>
  openDetails('template', template, tab);

export const openLinkDetails = (link, tab = 'analytics')=>
  openDetails('link', link, tab);

export const closePageDetails = (id)=> 
  (dispatch)=> {
    dispatch({
      type: UPDATE_SHARED_MANAGEMENT_MODAL,
      name: `${PAGE_DETAILS_MODAL_NAME}-${id}`,
      props: { isClosing: true }
    });
    setTimeout(()=> {
      dispatch(closeDetails('site'));
      dispatch({
        type: DESTROY_SHARED_MANAGEMENT_MODAL,
        name: `${PAGE_DETAILS_MODAL_NAME}-${id}`
      });  
    }, CLOSING_DURATION);
  };

export const closeTemplateDetails = (id)=>
  (dispatch)=> {
    dispatch({
      type: UPDATE_SHARED_MANAGEMENT_MODAL,
      name: `${TEMPLATE_DETAILS_MODAL_NAME}-${id}`,
      props: { isClosing: true }
    });
    setTimeout(()=> {
      dispatch(closeDetails('template'));
      dispatch({
        type: DESTROY_SHARED_MANAGEMENT_MODAL,
        name: `${TEMPLATE_DETAILS_MODAL_NAME}-${id}`
      });  
    }, CLOSING_DURATION);
  };

export const closeLinkDetails = (id)=>
  (dispatch)=> {
    dispatch({
      type: UPDATE_SHARED_MANAGEMENT_MODAL,
      name: `${LINK_DETAILS_MODAL_NAME}-${id}`,
      props: { isClosing: true }
    });
    setTimeout(()=> {
      dispatch(closeDetails('link'));
      dispatch({
        type: DESTROY_SHARED_MANAGEMENT_MODAL,
        name: `${LINK_DETAILS_MODAL_NAME}-${id}`
      });  
    }, CLOSING_DURATION);
  };

export const selectTabInLinkDetails = (tab)=>
  selectTabInDetails('link', tab);

export const selectTabInPageDetails = (tab)=>
  selectTabInDetails('site', tab);

export const selectTabInTemplateDetails = (tab)=>
  selectTabInDetails('template', tab);



export const openRouteDeleter = (routeId)=> 
  openManagementModal(ROUTE_DELETER_MODAL_NAME, { routeId: routeId });

export const cancelRouteDeleter = ()=>
  closeManagementModal(ROUTE_DELETER_MODAL_NAME);

export const confirmRouteDeleter = (routeId)=>
  (dispatch)=> {
    const route = routesStore.get().get(routeId);
    dispatch(closeManagementModal(ROUTE_DELETER_MODAL_NAME));
    dispatch(closeLinkDetails(routeId));

    getPageHistoryTrackerForPage(route.get('resource_id')).trackDeleteRoute();

    // Closing the details modal can be slow (due to the animation) so we
    // ensure it's closed before we actually make the delete.
    setTimeout(()=> {
      dispatch(deleteRoute(route));
    }, CLOSING_DURATION);
  };


export const openPageDeleter = (page)=>
  openManagementModal(PAGE_DELETER_MODAL_NAME, { pageId: page.id });

export const cancelPageDeleter = ()=>
  closeManagementModal(PAGE_DELETER_MODAL_NAME);

export const confirmPageDeleter = (pageId)=>
  (dispatch)=> {
    const page = pagesStore.get().get(pageId);
    dispatch(closeManagementModal(PAGE_DELETER_MODAL_NAME));
    dispatch(closePageDetails());

    getPageHistoryTrackerForPage(page.id).trackDeletePage();

    // Closing the details modal can be slow (due to the animation) so we
    // ensure it's closed before we actually make the delete.
    setTimeout(()=> {
      dispatch(deletePage(page));
    }, CLOSING_DURATION);
  };


export const openPageOrTemplateCreator = (asType, model)=>
  (dispatch)=> {
    if (!asType) {
      throw new Error('You must specify "site" or "template" type');
    }

    dispatch(openManagementModal(
      CREATE_PAGE_OR_TEMPLATE_MODAL_NAME,
      {
        asType,
        open: true,
        blank: !model ,
        fromTemplateId: (model && model.isTemplate()) ? model.id : undefined,
        fromPageId: (model && !model.isTemplate()) ? model.id : undefined
      }
    ));
    if (model) {
      dispatch(setFolderIdForNewPage(model.get('folder_id')));
    }
  };


export const closePageOrTemplateCreator = ()=> 
  closeManagementModal(CREATE_PAGE_OR_TEMPLATE_MODAL_NAME);


export const openCreatePageFromTemplateModal = ()=>
  openManagementModal(CREATE_PAGE_FROM_TEMPLATE_MODAL_NAME);

export const closeCreatePageFromTemplateModal = ()=> 
  closeManagementModal(CREATE_PAGE_FROM_TEMPLATE_MODAL_NAME);

export const openPageSharer = (page, { initialEmails=[], isSimpleEmailSendingMode=false }={})=>
  openManagementModal(LINK_SHARER_MODAL_NAME, { pageId: page, initialEmails, isSimpleEmailSendingMode });

export const closePageSharer = ()=>
  closeManagementModal(LINK_SHARER_MODAL_NAME);

export const openLinkSharer = (link, { initialEmails=[], isSimpleEmailSendingMode=false }={})=>
  openManagementModal(LINK_SHARER_MODAL_NAME, { routeId: link, initialEmails, isSimpleEmailSendingMode });


export const openSitePreviewCollaborationModal = (siteId)=>
  openManagementModal(SITE_PREVIEW_COLLABORATION_MODAL_NAME, { siteId });

export const closeSitePreviewCollaborationModal = () => (dispatch) => {
  dispatch(closeManagementModal(SITE_PREVIEW_COLLABORATION_MODAL_NAME));
};

export const closeLinkSharer = closePageSharer;

export const openLinkCreator = (pageOrId)=>
  openManagementModal(
    LINK_CREATOR_MODAL_NAME,
    {
      pageId: pageOrId.id ? pageOrId.id : pageOrId
    }
  );

export const closeLinkCreator = ()=>
  closeManagementModal(LINK_CREATOR_MODAL_NAME);



export const openFolderManager = (forPage = null)=>
  openManagementModal(
    FOLDER_MANAGER_MODAL_NAME,
    {
      forPageId: forPage ? forPage.id : null
    }
  );


export const openFolderManagerForNewPage = (forPage = null)=>
  (dispatch)=> {
    dispatch(openManagementModal(
      FOLDER_MANAGER_MODAL_NAME,
      {
        forPageId: forPage ? forPage.id : null,
        isForNewPage: true
      }
    ));
  };


export const closeFolderManager = ()=>
  (dispatch)=> {
    dispatch(closeManagementModal(FOLDER_MANAGER_MODAL_NAME));
  };


export const openPageRedirector = (page)=> 
  openManagementModal(PAGE_REDIRECTOR_MODAL_NAME, { pageId: page.id });


export const closePageRedirector = ()=> 
  closeManagementModal(PAGE_REDIRECTOR_MODAL_NAME);

export const openSiteDeactivator = (props)=> 
  openManagementModal(SITE_DEACTIVATOR_MODAL_NAME, props);

export const closeSiteDeactivator = ()=> 
  closeManagementModal(SITE_DEACTIVATOR_MODAL_NAME);

export const openSiteExporter = (site)=>
  openManagementModal(EXPORT_SITE_MODAL_NAME, { siteId: site.id });

export const closeSiteExpoter = ()=>
  closeManagementModal(EXPORT_SITE_MODAL_NAME);
